import {OsmMapRegionParams} from "../../../../../config/cities";
import {isRpRegionDistrictParentType, RpRegionType} from "../types/rp_region_type";

interface IRegionSelection {
    id: number;
    slug: string;
    type?: number;
}

/**
 * OSM `region-list-map` params for a picked RP region (explicit select / POC).
 * - type 4/5 (city, town): `parent={id}&type=6` for district polygons
 * - type 6+ (district, etc.): single polygon via `region={id}` (thematic fill from stats)
 */
export const resolveMapRegionParamsFromSelection = (region: IRegionSelection): OsmMapRegionParams => {
    if (region.type != null && isRpRegionDistrictParentType(region.type)) {
        return {
            regionsMapSlug: region.slug,
            regionsMapParentId: region.id,
            regionsMapRegionId: region.id,
            regionsMapChildType: RpRegionType.DISTRICT
        };
    }

    return {
        regionsMapSlug: region.slug,
        regionsMapRegionId: region.id
    };
};
